/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Text',
  definitions: {
    '24': {
      viewBox: '0 0 24 24',
      path: (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.40002 2.75039C1.40002 2.28095 1.78058 1.90039 2.25002 1.90039H21.75C22.2195 1.90039 22.6 2.28095 22.6 2.75039V9.37539C22.6 9.84483 22.2195 10.2254 21.75 10.2254H18.0076C17.5382 10.2254 17.1576 9.84483 17.1576 9.37539V7.25664H14.7212V17.3379H17.5076C17.977 17.3379 18.3576 17.7184 18.3576 18.1879V21.2504C18.3576 21.7198 17.977 22.1004 17.5076 22.1004H6.49245C6.02301 22.1004 5.64245 21.7198 5.64245 21.2504V18.1879C5.64245 17.7184 6.02301 17.3379 6.49245 17.3379H9.27881V7.25664H6.84245V9.37539C6.84245 9.84483 6.46189 10.2254 5.99245 10.2254H2.25002C1.78058 10.2254 1.40002 9.84483 1.40002 9.37539V2.75039ZM2.60002 3.10039V9.02539H5.64245V6.90664C5.64245 6.4372 6.02301 6.05664 6.49245 6.05664H9.62881C10.0983 6.05664 10.4788 6.4372 10.4788 6.90664V17.6879C10.4788 18.1573 10.0983 18.5379 9.62881 18.5379H6.84245V20.9004H17.1576V18.5379H14.3712C13.9018 18.5379 13.5212 18.1573 13.5212 17.6879V6.90664C13.5212 6.4372 13.9018 6.05664 14.3712 6.05664H17.5076C17.977 6.05664 18.3576 6.4372 18.3576 6.90664V9.02539H21.4V3.10039H2.60002Z"
            fill="currentColor"
          />
        </>
      ),
    },
    '32': {
      viewBox: '0 0 32 32',
      path: (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.06665 4.33372C2.06665 3.81826 2.48452 3.40039 2.99998 3.40039H29C29.5155 3.40039 29.9333 3.81826 29.9333 4.33372V13.1671C29.9333 13.6825 29.5155 14.1004 29 14.1004H24.0101C23.4946 14.1004 23.0767 13.6825 23.0767 13.1671V10.1421H19.4283V23.9837H23.3434C23.8589 23.9837 24.2768 24.4016 24.2768 24.9171V29.0004C24.2768 29.5159 23.8589 29.9337 23.3434 29.9337H8.65655C8.14108 29.9337 7.72322 29.5159 7.72322 29.0004V24.9171C7.72322 24.4016 8.14108 23.9837 8.65655 23.9837H12.5717V10.1421H8.92322V13.1671C8.92322 13.6825 8.50535 14.1004 7.98988 14.1004H2.99998C2.48452 14.1004 2.06665 13.6825 2.06665 13.1671V4.33372ZM3.26665 4.60039V12.9004H7.72322V9.87539C7.72322 9.35992 8.14108 8.94206 8.65655 8.94206H12.8384C13.3538 8.94206 13.7717 9.35992 13.7717 9.87539V24.2504C13.7717 24.7659 13.3538 25.1837 12.8384 25.1837H8.92322V28.7337H23.0767V25.1837H19.1616C18.6461 25.1837 18.2283 24.7659 18.2283 24.2504V9.87539C18.2283 9.35992 18.6461 8.94206 19.1616 8.94206H23.3434C23.8589 8.94206 24.2768 9.35992 24.2768 9.87539V12.9004H28.7333V4.60039H3.26665Z"
            fill="currentColor"
          />
        </>
      ),
    },
    '48': {
      viewBox: '0 0 48 48',
      path: (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.375 6.5C3.375 5.87868 3.87868 5.375 4.5 5.375H43.5C44.1213 5.375 44.625 5.87868 44.625 6.5V19.75C44.625 20.3713 44.1213 20.875 43.5 20.875H36.0152C35.3938 20.875 34.8902 20.3713 34.8902 19.75V14.9375H28.8674V36.25H35.0152C35.6365 36.25 36.1402 36.7537 36.1402 37.375V43.5C36.1402 44.1213 35.6365 44.625 35.0152 44.625H12.9848C12.3635 44.625 11.8598 44.1213 11.8598 43.5V37.375C11.8598 36.7537 12.3635 36.25 12.9848 36.25H19.1326V14.9375H13.1098V19.75C13.1098 20.3713 12.6062 20.875 11.9848 20.875H4.5C3.87868 20.875 3.375 20.3713 3.375 19.75V6.5ZM4.625 6.625V19.625H11.8598V14.8125C11.8598 14.1912 12.3635 13.6875 12.9848 13.6875H19.2576C19.8789 13.6875 20.3826 14.1912 20.3826 14.8125V36.375C20.3826 36.9963 19.8789 37.5 19.2576 37.5H13.1098V43.375H34.8902V37.5H28.7424C28.1211 37.5 27.6174 36.9963 27.6174 36.375V14.8125C27.6174 14.1912 28.1211 13.6875 28.7424 13.6875H35.0152C35.6365 13.6875 36.1402 14.1912 36.1402 14.8125V19.625H43.375V6.625H4.625Z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
};

const icon = createSvgIcon(config);
export default icon;
